const parseStringToHTML = (price: string) => {
    const htmlParser = new DOMParser()
    const html = htmlParser.parseFromString(price, 'text/html')
    return html.body.innerHTML
}

export default parseStringToHTML
